import { gql } from "@apollo/client";

export const EDITAR_SUSPENSION = gql`
    mutation EditarSuspension(
        $idSuspension: Int!, 
        $idEvaluacion: Int!,
        $idPaciente: Int!,
        $soloContrato: Boolean!,
        $idDelegacion: Int!,
        $idMotivo: Int!,
        $observacion: String,
        $fechaDesde: CustomDateTime!,
        $fechaHasta: CustomDateTime!,
        $fechaObito: CustomDateTime,
        $idDetalleObito: Int
    ) {
        editarSuspension(
            input: {
                idSuspension:$idSuspension,
                idEvaluacion:$idEvaluacion,
                idPaciente: $idPaciente,
                soloContrato: $soloContrato,
                idDelegacion: $idDelegacion,
                idMotivo: $idMotivo,
                observacion: $observacion,
                fechaDesde: $fechaDesde,
                fechaHasta: $fechaHasta,
                fechaObito: $fechaObito,
                idDetalleObito: $idDetalleObito
            }
        ) {
            success
            error
        }
    }
`;